import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DocumentTitle from 'react-document-title';
import { Button } from '@material-ui/core';
import AdvertisementsList from './AdvertisementsList';
import AdvertisementDialog from './AdvertisementDialog';
import { actions } from '../../actions/advertisementsActions';
import { actions as tenantsActions } from '../../actions/tenantsActions';

export class AdvertisementsPage extends React.Component {
  state = {
    advertisementDialogVisible: false,
    advertisementId: null,
    details: null,
    loading: false,
    dialogError: false,
    submitting: false
  }

  handleRefresh = () => {
    const { list, actions } = this.props;
    return actions.load(list.paging.pageNumber, list.paging.pageSize, list.sortedBy, list.filteredBy);
  }

  handleAddNewAdvertisement = () => this.handleOpenAdvertisement();

  handleOpenAdvertisement = async (id = null) => {
    this.setState({ advertisementDialogVisible: true, advertisementId: id, details: null, loading: true, dialogError: false });
    try {
      const [details] = await Promise.all([
        id ? this.props.actions.getDetails(id) : Promise.resolve({ success: true, data: null }),
        this.props.tenantsActions.loadFreshTenants(1, 1000000, [{ id: 'name', value: 'asc' }], []),
      ]);
      this.setState({ loading: false, dialogError: !details.success, details: details.data });
    } catch (error) {
      this.setState({ loading: false, dialogError: true });
    }
  }

  handleRetryAdvertisement = () => this.handleOpenAdvertisement(this.state.advertisementId);

  handleCancelAdvertisement = () => {
    if (!this.state.submitting && !this.state.loading) {
      this.setState({ advertisementDialogVisible: false });
    }
  }

  handleSaveAdvertisement = async values => {
    const { advertisementId, submitting } = this.state;
    if (submitting) return;

    this.setState({ submitting: true });
    try {
      const result = advertisementId
        ? await this.props.actions.update(advertisementId, values)
        : await this.props.actions.create(values);
      if (result.success) {
        this.setState({ advertisementDialogVisible: false });
        await this.handleRefresh();
      }
      return result;
    } finally {
      this.setState({ submitting: false });
    }
  }

  handlePublishAdvertisement = async id => {
    if (this.state.submitting) return;

    this.setState({ submitting: true });
    try {
      const result = await this.props.actions.publish(id);
      if (result.success) await this.handleRefresh();
      return result;
    } finally {
      this.setState({ submitting: false });
    }
  }

  handleDeleteAdvertisement = async id => {
    if (this.state.submitting) return;

    this.setState({ submitting: true });
    try {
      const result = await this.props.actions.delete(id);
      if (result.success) await this.handleRefresh();
      return result;
    } finally {
      this.setState({ submitting: false });
    }
  }

  render() {
    const { tenants } = this.props;
    const { submitting, advertisementDialogVisible, advertisementId, loading, dialogError, details } = this.state;
    
    return (
      <DocumentTitle title="Reklamy">
        <div className="page">
          <div style={{ padding: 16 }}>
            <div style={{ textAlign: 'right', marginBottom: 16 }}>
              <Button
                variant="contained"
                color="primary"
                disabled={submitting || loading}
                onClick={this.handleAddNewAdvertisement}
              >
                Dodaj reklamę
              </Button>
            </div>
            <AdvertisementsList
              busy={submitting || loading}
              onEdit={this.handleOpenAdvertisement}
              onPublish={this.handlePublishAdvertisement}
              onDelete={this.handleDeleteAdvertisement}
            />
            {advertisementDialogVisible && (
              <AdvertisementDialog
                open
                edit={Boolean(advertisementId)}
                loading={loading}
                error={dialogError}
                details={details}
                tenants={tenants}
                busy={submitting || loading}
                onSubmit={this.handleSaveAdvertisement}
                onCancel={this.handleCancelAdvertisement}
                onRetry={this.handleRetryAdvertisement}
              />
            )}
          </div>
        </div>
      </DocumentTitle>
    );
  }
}

AdvertisementsPage.propTypes = {
  actions: PropTypes.object.isRequired,
  tenantsActions: PropTypes.object.isRequired,
  list: PropTypes.object.isRequired,
  tenants: PropTypes.array.isRequired,
};

function mapStateToProps(state) {
  return {
    list: state.advertisements.pagedData,
    tenants: state.tenants.list.pagedData.records,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    tenantsActions: bindActionCreators(tenantsActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AdvertisementsPage);
